import imgIzzi51 from "./img-izzi5 (1).png";
import imgIzzi52 from "./img-izzi5 (2).png";
import imgIzzi53 from "./img-izzi5 (3).png";
import imgIzzi54 from "./img-izzi5 (4).png";
import imgIzzi55 from "./img-izzi5 (5).png";
import imgIzzi56 from "./img-izzi5 (6).png";
import imgIzzi57 from "./img-izzi5 (7).png";
import imgIzzi58 from "./img-izzi5 (8).png";
import imgIzzi59 from "./img-izzi5 (9).png";
import imgIzzi510 from "./img-izzi5 (10).png";

const imgIzzi5 = [
  imgIzzi51,
  imgIzzi52,
  imgIzzi53,
  imgIzzi54,
  imgIzzi55,
  imgIzzi56,
  imgIzzi57,
  imgIzzi58,
  imgIzzi59,
  imgIzzi510,
];

export default imgIzzi5;
